class AudioRejectionReason {
  PRONUNCIATION = "PRONUNCIATION";
  CONTENT_RECORDED_INCORRECTLY = "CONTENT_RECORDED_INCORRECTLY";
  MISSING_OR_INCORRECT_AUDIO_CONTENT = "MISSING_OR_INCORRECT_AUDIO_CONTENT";
  AUDIO_NOT_TIED_TO_CORRECT_METADATA = "AUDIO_NOT_TIED_TO_CORRECT_METADATA";
}

export default new AudioRejectionReason();
